import clienteAxios from "../config/axios";

export async function addSolicitudAjuste(formData) {
  return clienteAxios.post(`/solicitudAjuste`, formData, { headers: { "Content-Type": "multipart/form-data" }, timeout: 0 });
}

export async function addFiles(formData) {
  console.log(formData);
  return clienteAxios.post("/solicitudAjuste/file", formData, { headers: { "Content-Type": "multipart/form-data" }, timeout: 0 });
}

export async function updateSolicitudAjuste(formData) {
  return clienteAxios.put("/solicitudAjuste", formData, { headers: { "Content-Type": "multipart/form-data" }, timeout: 0 });
}

export async function deleteFile(fileName) {
  return clienteAxios.delete(`/solicitudAjuste/file/${fileName}`);
}

export async function getFiles(tDocCodFor, tDocNroFor) {
  return clienteAxios.get(`/solicitudAjuste/files/${tDocCodFor}/${tDocNroFor}`);
}

export async function getSolicitudesByFiltrosRango(filtros){
  return clienteAxios.get(`/solicitudAjuste/filtrosRango/${filtros}`);
}

export async function getSolicitudesByFiltrosRangoAndNroCta(nroCta, filtros){
  return clienteAxios.get(`/solicitudAjuste/nroCta/${nroCta}/filtrosRango/${filtros}`);
}

export async function getSolicitudesAjusteByNroCta(nroCta){
  return clienteAxios.get(`/getSolicitudesAjusteByNroCta/nroCta/${nroCta}`);
}
